/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-30 09:33:00
 * @LastEditors: hongye
 * @LastEditTime: 2025-09-30 10:02:36
 */
import { Router } from 'vue-router'
import { useSettingStore, useTabStore, useAuthStore } from '@/store'
import { restructureMeta, isObject } from '@/utils'

/** 处理菜单选中状态 */
function setMenuStatus(this: any, findMenu: { id: number; parentId: number }) {
  if (!isObject(findMenu)) return
  this.setSelectedKeys([findMenu.id])
}

/** 处理菜单打开状态 */
function setOpenStatus(this: any, findMenu: { id: number; parentId: number }) {
  if (!isObject(findMenu)) return
  this.setOpenkeys([findMenu.id])
}

//获取url所在对象
const getItemByUrl = (list: any[], url: string | number, level?: string) => {
  const isParent = level === 'parent'
  const newArray: any[] = []
  Array.isArray(list) &&
    list.length > 0 &&
    list.forEach((_) => {
      if (Array.isArray(_.childs) && _.childs.length > 0) {
        _.childs.forEach((v: any) => {
          newArray.push(v)
        })
      } else {
        newArray.push(_)
      }
    })
  const childMenu = newArray.find((item) => {
    return item.path === url
  })
  return isParent ? list.find((_) => childMenu?.parentId === _.id) : childMenu
}

const routerBefore = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    /** 白名单内的页面不放入到tabStore中 */
    const whiteList = ['/Login', '/login', '/smsCode', '/404', '/401', '/forgetPwd']
    const [settingStore, tabStore, authStore] = [useSettingStore(), useTabStore(), useAuthStore()]
    if (!whiteList.includes(to.path)) {
      if (!authStore.isLoggedIn) {
        next('/login')
        return
      }
      if (to.meta.requiresSwitching && !authStore.userInfo?.switching) {
        next('/noAuth')
        return
      }
      const childMenu = getItemByUrl(authStore.menuList, to.path)
      const parentMenu = getItemByUrl(authStore.menuList, to.path, 'parent')
      //处理菜单选中状态
      setMenuStatus.call(settingStore, childMenu)
      setOpenStatus.call(settingStore, parentMenu)
      tabStore.setTabs({ name: to.name as string, path: to.fullPath, meta: restructureMeta(to) })
    }
    next()
  })
}

export default routerBefore
